// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1WYNt","dragIcon":"SortableItem_dragIcon__26DHd","disabled":"SortableItem_disabled__2EsMs"};